<template>
    <v-container fluid>
        <v-img
            class="white--text align-top"
            height="200px"
            gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
            src='/images/mantenimiento.jpg'
        >
            <v-card-title justify-top>
                Mantenimiento y Soporte Técnico
            </v-card-title>
        </v-img>

        <!-- Navegación de tabs -->
        <v-sheet elevation="2" class="mb-2">
            <v-tabs
                v-model="tab"
                background-color="#009639"
                dark
                grow
            >
                <v-tab to="/mtto/tickets">
                    <v-icon left>mdi-ticket</v-icon>
                    Sistema de Tickets
                </v-tab>
            </v-tabs>
        </v-sheet>

        <!-- Contenido de las rutas hijas -->
        <v-sheet elevation="2">
            <transition name="fade" mode="out-in">
                <router-view/>
            </transition>
        </v-sheet>
    </v-container>
</template>

<script>
export default {
    name: 'MttoPrincipal',
    
    data: () => ({
        tab: null,
    }),
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>

